import type { Sport } from '@shared/types';

/**
 * Deportes visibles en esta compilación (`VITE_SPORTS`, al compilar). Vacío: todos (la web).
 * La app Android solo de béisbol se compila con `VITE_SPORTS=baseball`: fútbol y básquet se
 * ocultan (portada, salas, lobby, «Cómo se juega») sin borrar su código.
 * Acepta los nombres en español o en inglés, separados por comas.
 */
export const ALL_SPORTS: readonly Sport[] = ['futbol', 'beisbol', 'basquetbol'];

const ALIASES: Record<string, Sport> = {
  futbol: 'futbol',
  football: 'futbol',
  soccer: 'futbol',
  beisbol: 'beisbol',
  baseball: 'beisbol',
  basquetbol: 'basquetbol',
  basquet: 'basquetbol',
  basketball: 'basquetbol',
};

export const parseSports = (raw: string | undefined): readonly Sport[] => {
  const picked = (raw ?? '')
    .split(',')
    .map((s) => ALIASES[s.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')])
    .filter((s): s is Sport => !!s);
  // Un valor sin ningún deporte válido no deja la app vacía: se muestran todos.
  return picked.length ? ALL_SPORTS.filter((s) => picked.includes(s)) : ALL_SPORTS;
};

export const ENABLED_SPORTS = parseSports(import.meta.env.VITE_SPORTS);

export const isSportEnabled = (sport: Sport): boolean => ENABLED_SPORTS.includes(sport);

/** El único deporte de la compilación, o null si hay varios (sin filtro por categorías). */
export const SINGLE_SPORT: Sport | null = ENABLED_SPORTS.length === 1 ? ENABLED_SPORTS[0]! : null;

/** Aviso al salir de una sala de un deporte que esta versión no incluye. */
export const SPORT_UNAVAILABLE_NOTICE = 'Ese deporte no está disponible en esta versión de la app.';
